// extracted by mini-css-extract-plugin
export default {"advertTab":"wylQW3LN"};